/**
 * Page backdrop. The premium mockup is a clean cream/white canvas with
 * NO floating diamond wireframes behind content — so this renders only
 * a whisper-soft radial tint (defined in styles/index.css via the
 * `.diamond-backdrop` class) and no SVG glyphs whatsoever.
 *
 * Kept exported (and mounted from App.tsx) so the layout tree is
 * unchanged; it simply no longer paints any diamond silhouettes.
 */
export function DiamondBackdrop() {
  return <div aria-hidden className="diamond-backdrop" />
}
